@if (openExitDialog) {
<div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
  <div class="h-full w-full">
    <div class="cancelDialog">
      <p class="font-bold z-10">Sure you want to leave?</p>
      <p class="mt-3 z-10">Your changes are not saved automatically and will be discarded if you exit now. Make sure to
        save your changes before you exit.</p>
      <fa-icon class="mt-3 z-10" [icon]="faTriangleExclamation" size="5x"></fa-icon>
      <div class="h-[38px] mt-5 flex flex-row z-10">
        <full-button [marginRight]="true" (click)="openExitDialog = false" text="Cancel" />
        <outline-button (click)="exitImport()" text="Exit Now" />
      </div>
      <fa-icon class="backgroundExit" [icon]="faTriangleExclamation" size="10x"></fa-icon>
    </div>
  </div>
</div>
}
@if (sampleFileOpen) {
<div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
  <div class="h-full w-full">
    <div class="sampleFile">
      <div class="flex flex-col h-full w-full p-5 overflow-y-hidden">
        <div class="flex-none">
          <div class="flex flex-row justify-between pb-1">
            <p class="text-center font-semibold text-xl">Sample .CSV file table</p>
            <button class="hover:bg-gray-100 rounded-full p-0.5 w-8 h-8 ml-1" (click)="sampleFileOpen = false"
              aria-label="Close Sample File">
              <fa-icon [icon]="faXmark"></fa-icon>
            </button>
          </div>
        </div>
        <table class="mt-2">
          <tr>
            <th>name</th>
            <th>netID</th>
            <th>email</th>
          </tr>
          <tr>
            <td>Robert</td>
            <td>1234</td>
            <td>example&#64;email.net</td>
          </tr>
        </table>
        <p class="mt-3 text-sm">
          This is the format for the .csv file that you upload. Have the three columns labeled with the headers name,
          netID, and email with the corresponding information for each student on each row underneath. NOTE: The headers
          for each column are case sensitive.
        </p>
      </div>
    </div>
  </div>
</div>
}
@if (successImportDialog) {
<div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
  <div class="h-full w-full">
    <div class="sampleFile">
      <div class="min-w-[350px] flex flex-col gap-2 h-full w-full p-5 overflow-y-hidden">
        <div class="flex-none pb-2">
          @if (successImportResponse != null) {
          <div class="flex flex-row justify-center mb-2">
            @if (successImportResponse.allnew !== 0 && successImportResponse.justroles == 0) {
            <p class="font-semibold text-lg">User List Uploaded!</p>
            }
            @if (successImportResponse.justroles !== 0) {
            <p class="font-semibold text-lg">Import User List</p>
            }
            @if ((successImportResponse.allnew == 0 || userFieldsValidationError) && successImportResponse.justroles ==
            0) {
            <p class="font-semibold text-lg text-red-600">Import Error</p>
            }
          </div>
          }
          <hr class="bg-gray-50 mb-6" />
          @if (userFieldsValidationError) {
          <div>
            <p class="text-center">Please fill in all fields.</p>
            <p class="text-red-600 text-center"><b>Name, NetId, Email</b> are required.</p>
          </div>
          }
          @if (successImportResponse != null) {
          <div class="flex flex-col gap-4">
            @if (successImportResponse.allnew !== 0) {
            <div>
              <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                New Users Added: {{successImportResponse.allnew}}
              </div>
              <p class="text-[#74808B] text-sm pl-1.5">Brand new users</p>
            </div>
            }
            @if (successImportResponse.justroles !== 0) {
            <div>
              <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                Existing Users with New Roles: {{successImportResponse.justroles}}
              </div>
              <p class="text-sm text-[#74808B] pl-1.5">Existing users had this role added to them</p>
            </div>
            }
            @if (successImportResponse.nochange !== 0) {
            <div>
              <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                Duplicated users: {{successImportResponse.nochange}}
              </div>
              <p class="text-red-600 text-sm pl-1.5 pt-1">Users that already exist with this role.</p>
            </div>
            }
            @if (successImportResponse.nouname !== 0) {
            <div>
              <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                No Username Users: {{successImportResponse.nouname}}
              </div>
              <p class="text-red-600 text-sm pl-1.5">Users within the .csv that did not have a username provided</p>
            </div>
            }
            @if (successImportResponse.noemail !== 0) {
            <div>
              <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                No Email Users: {{successImportResponse.noemail}}
              </div>
              <p class="text-red-600 text-sm pl-1.5">Users within the .csv that did not have an email provided</p>
            </div>
            }
            @if (successImportResponse.errors !== 0) {
            <div>
              <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                Error Users: {{successImportResponse.errors}}
              </div>
              <p class="text-red-600 text-sm pl-1.5 pt-1">Users that NetID already exist with this role. Please provide
                a different one.</p>
            </div>
            }
            @if (successImportResponse.badroles !== 0) {
            <div>
              <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                Incomplete Users: {{successImportResponse.badroles}}
              </div>
              <p class="text-red-600 text-sm pl-1.5">Users with incomplete info</p>
            </div>
            }
          </div>
          }
        </div>
        <clear-button (click)="exitImport()" text="Exit" />
      </div>
    </div>
  </div>
</div>
}
@if (openAddRoleDialog) {
<div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
  <div class="h-full w-full">
    <div
      class="absolute flex flex-col shadow rounded-[16px] bg-white h-fit w-[450px] m-auto bottom-0 top-0 left-0 right-0 p-5 text-left">
      <!-- TODO add on selection to load the role's subjects and units -->
      <p class="font-bold z-10 mt-3">Add new role</p>
      <dropdown-search [getRoleDetails]="true" [items]="roles" [addedList]="addedTempUserRole" [singleItemList]="true"
        placeholder="Search for roles" class="mt-2" />
      @if (addedTempUserRole.length > 0) {
      <div>
        @if (addedTempUserRole[0].subjects != null && addedTempUserRole[0].subjects.length !== 0 ||
        addedTempUserRole[0].units != null && addedTempUserRole[0].units.length !== 0) {
        <p class="text-sm mt-2">
          You can optionally add the context of this user's role. For this initial role during user creation you can
          only have one subject and one unit. By default they will have the role's permission system wide.
        </p>
        }
        @if (addedTempUserRole[0].organizations != null && addedTempUserRole[0].organizations.length !== 0) {
        <div>
          <p class="mt-3 text-sm">Organizations</p>
          <dropdown-search [items]="addedTempUserRole[0].organizations" [addedList]="addedOrgList"
            [singleItemList]="true" [isOrganization]="true" placeholder="Choose organizations" />
          @for (org of addedOrgList; track org; let i = $index) {
          <chip [text]="org.organization_name != undefined? org.organization_name: ''"
            (click)="addedOrgList.splice(i,1)" />
          }
        </div>
        }
        @if (addedTempUserRole[0].subjects != null && addedTempUserRole[0].subjects.length !== 0) {
        <div>
          <p class="mt-3 text-sm">Subjects</p>
          <dropdown-search [items]="addedTempUserRole[0].subjects" [addedList]="addedSubjectList"
            [singleItemList]="true" [isSubject]="true" placeholder="Choose subjects" />
          @for (subject of addedSubjectList; track subject; let i = $index) {
          <chip [text]="subject.subject_name != undefined? subject.subject_name: ''"
            (click)="addedSubjectList.splice(i,1)" />
          }
        </div>
        }
        @if (addedTempUserRole[0].units != null && addedTempUserRole[0].units.length !== 0) {
        <div>
          <p class="mt-3 text-sm">Units</p>
          <dropdown-search [items]="addedTempUserRole[0].units" [addedList]="addedUnitList" [singleItemList]="true"
            [isUnit]="true" placeholder="Choose units" />
          @for (unit of addedUnitList; track unit; let i = $index) {
          <chip [text]="unit.unit_name != undefined? unit.unit_name: ''" (click)="addedUnitList.splice(i,1)" />
          }
        </div>
        }
        @if (addedTempUserRole[0].courses != null && addedTempUserRole[0].courses.length !== 0) {
        <div>
          <p class="mt-3 text-sm">Units</p>
          <dropdown-search [items]="addedTempUserRole[0].courses" [addedList]="addedCourseList" [singleItemList]="true"
            [isCourse]="true" placeholder="Choose courses" />
          @for (course of addedCourseList; track course; let i = $index) {
          <chip [text]="course.course_name != undefined? course.course_name: ''"
            (click)="addedCourseList.splice(i,1)" />
          }
        </div>
        }
      </div>
      }
      <div class="flex justify-end mt-2">
        <outline-button [marginRight]="true" (click)="openAddRoleDialog = false" text="Cancel" />
        <full-button (click)="saveNewRole(addedTempUserRole)" text="Save Role configuration" />
      </div>
    </div>
  </div>
</div>
}
<breadcrumb endText="Import Users" [navigations]="breadcrumbNavs" />
<div class="m-8">
  <div>
    <div class="flex justify-between mb-1">
      <h1 class="font-semibold text-xl">
        Import User List
      </h1>
      <div class="flex gap-1">
        <clear-button (click)="autoImportNavigate()" [faIcon]="faGear" text="Configure Automatic Roster Import" />
      </div>
    </div>
    <hr />
    <div class="text-sm mt-5">
      <p>This page is designed to help you import a new user list using a .CSV file.</p>
      <p>Please upload the file with the correct format and ensure that the information you provide is accurate and
        up-to-date.</p>
    </div>
  </div>
  <div class="border border-[#5D6974] rounded-xl py-2 px-3 mt-5 flex flex-col" [formGroup]="importForm">
    <p>
      View Sample File Format:
    </p>
    <div class="my-3">
      <outline-button (click)="sampleFileOpen = true" text="Sample File" />
    </div>
    <p>
      Browse and Upload .CSV File:
    </p>
    <div class="my-3 flex flex-row">
      <input formControlName="csv" type="file" accept=".csv" (change)="onChange($event)" />
    </div>
    @if (userValidation) {
    <p class="text-sm text-red-500 font-semibold">No file selected</p>
    }
    @if (data.length !== 0) {
    <table class="mt-2 w-[80%]">
      <tr>
        <th>name</th>
        <th>netID</th>
        <th>email</th>
      </tr>
      @for (person of data | slice:0:3; track person) {
      <tr>
        <td>{{person.name}}</td>
        <td>{{person.netID}}</td>
        <td>{{person.email}}</td>
      </tr>
      }
    </table>
    }
    @if (data.length > 3) {
    <p class="mt-2">... found {{data.length - 3}} more rows</p>
    }
    <div class="mt-3">
      <div class="flex items-center">
        <p class="py-1">
          Assign Role To Users:
        </p>
        <clear-button (click)="openAddRoleDialog = true" text="Add role" />
      </div>
      @if (roleValidation) {
      <p class="text-sm text-red-500 font-semibold">At least one role is required</p>
      }
      @for (role of addedUserRoles; track role) {
      <div>
        <chip (click)="addedUserRoles = removeItemFromList(role, addedUserRoles)" [text]="role.name" />
      </div>
      }
    </div>
    <div class="flex flex-row justify-end mt-5">
      <outline-button [marginRight]="true" (click)="_location.back()" text="Cancel" />
      <full-button (click)="submit()" text="Submit" />
    </div>
  </div>
</div>